
import { useEffect, useState } from "react";
import { getCart } from "../../helpers/cart";
import {updateCart, getProductFromCart, removeFromCart} from '../../helpers/cart'
import { BsPlus, BsDash,BsTrash } from "react-icons/bs";


const CartDetail = () => {

    const [cartProduct,setCartProduct] = useState([]);

    useEffect(() => {
        const handleCartUpdate = () => {
            setCartProduct(getCart());
        };

        // Run once on mount
        handleCartUpdate();

        // Listen for future updates
        window.addEventListener("cartUpdated", handleCartUpdate);

        return () => {
            window.removeEventListener("cartUpdated", handleCartUpdate);
        };
    }, []);


    console.log(cartProduct);

    return(
        <section className="container my-4">
            <div className="table-responsive">
                <table className="table table-striped table-bordered align-middle text-center">
                    <thead className="">
                        <tr>
                            <th>#</th>
                            <th>Product Name</th>
                            <th>Product Number</th>
                            <th>Quantity</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            cartProduct.map((pro, index) => (
                                <tr key={pro.product.product__ID}>
                                    <td>{index + 1}</td>
                                    <td>{pro.product.product__Name}</td>
                                    <td>{pro.product.product__Number}</td>
                                    <td>{pro.quantity}</td>
                                    <td>
                                        <button 
                                            className="cart-trash-btn" 
                                            onClick={() => {
                                                    removeFromCart(pro.product.product__ID)
                                                    }}
                                        >
                                            <BsTrash/>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </section>

    );
}


export default CartDetail;